export const getPasswordValidationDetails = (
	password: string,
	confirmPassword?: string
) => {
	const hasValidLength = password.length >= 9 && password.length <= 15
	const hasNumber = /[0-9]/.test(password)
	const hasUpperCase = /[A-Z]/.test(password)
	const hasLowerCase = /[a-z]/.test(password)
	const hasSpecialChar = /[!@#$%^&*_+\-=\[\];:"\\|,.{}\/?]/.test(password)
	const hasInvalidSpecialChar = /[<>()']/.test(password)
	const hasNoSpaces = !/\s/.test(password)

	const isValid =
		hasValidLength &&
		hasNumber &&
		hasUpperCase &&
		hasLowerCase &&
		hasSpecialChar &&
		!hasInvalidSpecialChar &&
		hasNoSpaces

	return {
		hasValidLength,
		hasNumber,
		hasUpperCase,
		hasLowerCase,
		hasSpecialChar,
		hasInvalidSpecialChar,
		hasNoSpaces,
		isValid,
		passwordsMatch: confirmPassword ? password === confirmPassword : true
	}
}

export const validatePassword = (password: string): boolean => {
	return getPasswordValidationDetails(password).isValid
}
